import { Dialog, DialogTitle, Transition, TransitionChild } from "@headlessui/react"
import { XMarkIcon } from "@heroicons/react/24/solid"
import { Fragment } from "react/jsx-runtime"


interface ModalDialogProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    children: React.ReactNode;
    title?: string;
    allowClose?: boolean;
    className?: string;
}

export const ModalDialog: React.FC<ModalDialogProps> = ({ open, setOpen, children, title, allowClose = true , className=""}) => {



    const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (event.target === event.currentTarget && allowClose) {
            setOpen(false)
        }
    };
    return <Transition show={open} as={Fragment}>
        <Dialog as="div" className="fixed inset-0 z-30 overflow-y-auto " onClose={() => setOpen(false)}>
            <div className="flex items-center justify-center min-h-screen bg-gray-800 bg-opacity-75 p-4" onClick={handleBackdropClick}>
                <TransitionChild
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                >
                    <div className={`bg-white  dark:bg-gray-900 dark:text-gray-100 p-6  rounded-lg shadow-lg w-full space-y-4 ${className || "max-w-md" }`} onClick={(e) => e.stopPropagation()}>
                        <DialogTitle className="text-lg font-semibold text-gray-900 dark:text-gray-100 flex justify-between items-center">
                            <div>{title}</div>
                            <div className="text-right">
                                {allowClose &&
                                    <button onClick={() => setOpen(false)} className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
                                        <XMarkIcon className="h-6 w-6" />
                                    </button>
                                }
                            </div>
                        </DialogTitle>
                        <div className="py-2">
                            {children}
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </Transition>
}
